import { render, staticRenderFns } from "./classroom-manage.vue?vue&type=template&id=6bd8212e&scoped=true"
import script from "./classroom-manage.vue?vue&type=script&lang=js"
export * from "./classroom-manage.vue?vue&type=script&lang=js"
import style0 from "./classroom-manage.vue?vue&type=style&index=0&id=6bd8212e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8212e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd8212e')) {
      api.createRecord('6bd8212e', component.options)
    } else {
      api.reload('6bd8212e', component.options)
    }
    module.hot.accept("./classroom-manage.vue?vue&type=template&id=6bd8212e&scoped=true", function () {
      api.rerender('6bd8212e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/classroom-manage.vue"
export default component.exports